import { Editor } from '@tiptap/core';
import { forwardRef, useCallback, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import {
  CommandPickerFloatingTriggerProps,
  CommandPickerFloatingTriggerVisibleProps,
} from '../types';
import { AddButton } from './components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover .blue-line {
    opacity: 1;
  }
`;

// const BlueLine = styled.div`
//   width: 652px;
//   height: 2px;
//   background-color: var(--blue-30);
//   margin-left: 8px;
//   opacity: 0;
//   transition: opacity 0.2s ease;
// `;

interface Props {
  floatingTriggerProps: CommandPickerFloatingTriggerProps;
  editor: Editor;
}
export type CommandPickerFloatingTriggerRef = {
  update: (props: CommandPickerFloatingTriggerProps) => void;
};
const isVisible = (
  props: CommandPickerFloatingTriggerProps,
): props is CommandPickerFloatingTriggerVisibleProps => {
  return props.visible;
};

export const CommandPickerFloatingTrigger = forwardRef<
  CommandPickerFloatingTriggerRef,
  Props
>(({ floatingTriggerProps, editor }, ref) => {
  const [triggerProps, setTriggerProps] = useState(floatingTriggerProps);
  const addPlaceholder = useCallback(() => {
    if (isVisible(triggerProps)) {
      editor
        .chain()
        .setTextSelection({
          from: triggerProps.nodePositionInEditor,
          to: triggerProps.nodePositionInEditor,
        })
        .focus()
        .addCommandTriggerPlaceholder(triggerProps.nodePositionInEditor)
        .run();
    }
  }, [editor, triggerProps]);

  useImperativeHandle(ref, () => ({
    update: (props: CommandPickerFloatingTriggerProps) => {
      setTriggerProps(props);
    },
  }));

  return isVisible(triggerProps) ? (
    <Wrapper
      style={{
        position: 'absolute',
        left: triggerProps.position.left - 40,
        top: triggerProps.position.top - 30,
      }}
      className="command-picker-floating-trigger"
    >
      <AddButton onClick={addPlaceholder} />
    </Wrapper>
  ) : null;
});

CommandPickerFloatingTrigger.displayName = 'CommandPickerFloatingTrigger';
